document.addEventListener('DOMContentLoaded', () => {
    const SELECTORS = {
      FILTER_BUTTON: '.js-filter-button',
      FILTER_CONTENT: '.collection-filters-form',
      FILTER_DRAWER: '.CollectionFilters.Drawer',
      FILTER_CLOSE_BUTTON: '.CollectionFilters .Drawer__Close',
      FILTER_BUTTON_GROUP: '.filter__button-group',
      FILTER_ITEM_BUTTON: '.filter__item-button',
      LAYOUT: '.CollectionToolbar__Item--layout',
      LAYOUT_BUTTON: '.js-layout-button',
      LAYOUT_CHECKBOX: '#productmodal_checkbox',
      LAYOUT_TYPE: '.CollectionToolbar__LayoutType',
      SORT_BUTTON: '.js-sort-button',
      SORT_OPTION_BUTTON: '.js-sort-option-button',
      SORT_SELECT: '.collection-sortby-select',
      SWITCH_IMAGE_BUTTON: '.js-switch-product-image',
    };
    const CLASSLIST = {
        ACTIVE: 'is-active',
        EXPANDED: 'expanded',
        MODEL: 'model'
    };

    function calculateFiltersDrawerPosition(filterButton) {
      const drawer = document.querySelector(SELECTORS.FILTER_DRAWER);
      const filterContent = document.querySelector(SELECTORS.FILTER_CONTENT);
      if (filterContent) {
        const buttonRect = filterButton.getBoundingClientRect();
        const topPosition = buttonRect.bottom + 15;
        filterContent.style.top = `${topPosition}px`;
      }
      if (drawer && window.innerWidth > 768) {
        const buttonRect = filterButton.getBoundingClientRect();
        const leftPosition = buttonRect.left;
        const drawerWidth = window.innerWidth - leftPosition;
        drawer.style.width = `${drawerWidth}px`;
      } else if (drawer) {
        drawer.style.width = '100vw';
      }
    }

    function addToolbarFilterEvents() {
        const filterButton = document.querySelector(SELECTORS.FILTER_BUTTON);
        const drawer = document.querySelector(SELECTORS.FILTER_DRAWER);
        const filterContent = document.querySelector(SELECTORS.FILTER_CONTENT);
        if (filterButton) {
          calculateFiltersDrawerPosition(filterButton);
          filterButton.addEventListener('click', () => {
            calculateFiltersDrawerPosition(filterButton);
          });
        }
        if (drawer && filterContent) {
          drawer.addEventListener('click', (event) => {
            if (!filterContent.contains(event.target)) {
              const closeButton = document.querySelector(SELECTORS.FILTER_CLOSE_BUTTON);
              if (closeButton) {
                closeButton.click();
              }
            }
          });
        }
    }

    function addToolbarSortEvents() {
        const sortButton = document.querySelector(SELECTORS.SORT_BUTTON);
        const sortOptionButtons = document.querySelectorAll(SELECTORS.SORT_OPTION_BUTTON);
        if (sortButton) {
          sortButton.parentElement.addEventListener('mouseout', (event) => {
            if (!sortButton.parentElement.contains(event.relatedTarget)) {
              sortButton.parentElement.classList.remove(CLASSLIST.EXPANDED);
            }
          });
          sortButton.addEventListener('click', () => {
            sortButton.parentElement.classList.add(CLASSLIST.EXPANDED);
          });
        }
        sortOptionButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
              const select = document.querySelector(SELECTORS.SORT_SELECT);
              if (event.target.dataset.sort) {
                select.value = event.target.dataset.sort;
                select.dispatchEvent(new Event('change'));
              }
          });
        });
    }

    function addToolbarLayoutEvent() {
        const layoutButtons = document.querySelectorAll(SELECTORS.LAYOUT_BUTTON);
        layoutButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const clickedButton = event.target.closest(SELECTORS.FILTER_ITEM_BUTTON);
                const layoutComponent = document.querySelector(SELECTORS.LAYOUT);
                const gridType = clickedButton.getAttribute('data-grid-type');
                const count = clickedButton.getAttribute('data-count');
                const selector = `${SELECTORS.LAYOUT_TYPE}[data-grid-type="${gridType}"][data-count="${count}"]`;
                const toolbarButton = layoutComponent.querySelector(selector);
                if (toolbarButton) {
                  toolbarButton.click();
                  clickedButton.classList.add(CLASSLIST.ACTIVE);
                  Array.from(clickedButton.parentElement.children).forEach((sibling) => {
                    if (sibling !== clickedButton) {
                      sibling.classList.remove(CLASSLIST.ACTIVE);
                    }
                  });
                }
            });
        });
    }

    function addToolbarImageTypeEvent() {
        const switchProductImageButtons = document.querySelectorAll(SELECTORS.SWITCH_IMAGE_BUTTON);
        switchProductImageButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            const clickedButton = event.target.closest(SELECTORS.FILTER_ITEM_BUTTON);
            const checkbox = document.querySelector(SELECTORS.LAYOUT_CHECKBOX);
            const buttons = Array.from(event.target.closest(SELECTORS.FILTER_BUTTON_GROUP).children);
            if (clickedButton && checkbox) {
                buttons.forEach((sibling) => {
                    sibling.classList.remove(CLASSLIST.ACTIVE);
                });
                checkbox.checked = clickedButton.classList.contains(CLASSLIST.MODEL);
                clickedButton.classList.add(CLASSLIST.ACTIVE);
                const event = new Event('change', {
                    bubbles: true,
                    cancelable: true
                });
                checkbox.dispatchEvent(event);
            }
          });
        });
    }

    addToolbarFilterEvents();
    addToolbarSortEvents();
    addToolbarLayoutEvent();
    addToolbarImageTypeEvent();
  });